import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  & > :first-child {
    margin-bottom: 8px;
  }
`;

export const FormulaWrapper = styled.div`
  display: flex;
  margin-top: 16px;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  margin-bottom: 16px;
  justify-content: flex-end;
  gap: 8px;
`;
